var exports = {
  "d": "x936d19a0--e5b95f--star",
  "P": "x936d19a0--e5b95f--underlay",
};

module.exports = exports;
